import Hammer from 'hammerjs/hammer.js';

/* Document ready*/
$(function() {
  $(document).on('click', '.js-close-search', function(e) {
    e.preventDefault();
    $('.content-wrapper__search-box').hide();
  });

  $(document).on('click', '.js-search', function(e) {
    e.preventDefault();
    $('.content-wrapper__search-box').show();
  });

  $(document).on('click', '.js-main-nav', function(e) {
    e.preventDefault();
    $('.main-nav').toggleClass('main-nav_visible');
  });

  delete Hammer.defaults.cssProps.userSelect;
  var hammertime = new Hammer(document.body);
  hammertime.on('swipe', function(ev) {
    if(ev.direction === Hammer.DIRECTION_RIGHT) {
      $('.main-nav').toggleClass('main-nav_visible', true);
    }

    if(ev.direction === Hammer.DIRECTION_LEFT) {
      $('.main-nav').toggleClass('main-nav_visible', false);
    }
  });
});

/* Yandex.Search form */
(function(w,d,c) {
  var s=d.createElement('script'),h=d.getElementsByTagName('script')[0],e=d.documentElement;
  if((' '+e.className+' ').indexOf(' ya-page_js_yes ')===-1){
    e.className+=' ya-page_js_yes';
  }
  s.type='text/javascript';
  s.async=true;
  s.charset='utf-8';
  s.src=(d.location.protocol==='https:'?'https:':'http:')+'//site.yandex.net/v2.0/js/all.js';
  h.parentNode.insertBefore(s,h);(w[c]||(w[c]=[])).push(function(){
    Ya.Site.Form.init()
  })
})(window,document,'yandex_site_callbacks');
